const initialState = [
  {
    getAllMovies: [],
    getMovieInfo: [],
    getMovieCategory: [],
    isLoading: false,
    isInfoLoading: false,
  },
];

const movieReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_REDUCER_STATE":
      return {
        ...initialState,
      };
    case "GET_MOVIE_LIST":
      return {
        ...state,
        getAllMovies: action.payload,
      };

    case "GET_MOVIE_INFO":
      return {
        ...state,
        getMovieInfo: action.payload,
      };
    case "GET_MOVIE_CATEGORY":
      return {
        ...state,
        getMovieCategory: action.payload,
      };
    case "LOADING_START":
      return {
        ...state,
        isLoading: true,
      };
    case "LOADING_END":
      return {
        ...state,
        isLoading: false,
      };
    case "MOVIE_INFO_LOADING_START":
      return {
        ...state,
        isInfoLoading: true,
      };
    case "MOVIE_INFO_LOADING_END":
      return {
        ...state,
        isInfoLoading: false,
      };
    default:
      return state;
  }
};

export default movieReducer;
